/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import { Select, Button, Typography, Card, Alert, Divider, Spin, Empty } from "antd";
import Image from "antd/es/image";

import mainLogo from "../../assets/logo-bpom.png";
import downloadJuknis from "../../assets/juknis-crop.png";

const { Title, Text } = Typography;

export default function App() {
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await fetch("/tools-assessment.json", {
          headers: {
            Accept: "application/json",
          },
        });

        if (!res.ok) {
          throw new Error(`Gagal load JSON. Status: ${res.status}`);
        }

        const json = await res.json();

        if (!Array.isArray(json)) {
          throw new Error("Format JSON tidak valid. Harus berupa array.");
        }

        setData(json);
      } catch (err) {
        console.error("Error loading tools-assessment.json:", err);
        setError(err.message || "Terjadi kesalahan saat memuat data.");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const options = useMemo(() => {
    return data.map((d) => ({
      label: d.name,
      value: d.name,
    }));
  }, [data]);

  const handleChange = (value) => {
    const item = data.find((x) => x.name === value) || null;
    setSelected(item);
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f5f5f5", padding: "30px" }}>
      <Card
        style={{
          maxWidth: 650,
          margin: "0 auto",
          padding: 24,
          borderRadius: 12,
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <Image src={mainLogo} width={80} preview={false} />
        </div>

        <Title level={3} style={{ textAlign: "center", color: "#0053a0" }}>
          Tools Assessment Maturitas Industri Farmasi 2026
        </Title>

        <Text
          type="secondary"
          style={{ display: "block", textAlign: "center", marginBottom: 30 }}
        >
          Direktorat Pengawasan Produksi Obat Narkotika Psikotropika dan Prekursor
        </Text>

        {loading ? (
          <div style={{ textAlign: "center", padding: "24px 0" }}>
            <Spin size="large" />
            <div style={{ marginTop: 12 }}>
              <Text type="secondary">Memuat data tools assessment...</Text>
            </div>
          </div>
        ) : error ? (
          <Alert
            type="error"
            showIcon
            message="Gagal memuat data"
            description={error}
            style={{ marginBottom: 20 }}
          />
        ) : data.length === 0 ? (
          <Empty description="Data tools assessment tidak ditemukan" />
        ) : (
          <>
            <Text strong>Pilih Industri Farmasi:</Text>
            <Select
              showSearch
              options={options}
              placeholder="-- Pilih Industri --"
              style={{ width: "100%", marginTop: 10 }}
              onChange={handleChange}
              optionFilterProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
            />

            {selected && (
              <>
                <Alert
                  message="Email yang diberi akses untuk membuka Tools Assessment:"
                  description={
                    selected.emails?.length ? (
                      <div>
                        {selected.emails.map((email) => (
                          <div key={email}>
                            <Text strong>{email}</Text>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <Text strong>{selected.email || "-"}</Text>
                    )
                  }
                  type="info"
                  showIcon
                  style={{ marginTop: 25 }}
                />

                <Button
                  type="primary"
                  block
                  size="large"
                  href={selected.link}
                  target="_blank"
                  rel="noreferrer"
                  style={{ marginTop: 20 }}
                >
                  Buka Tools Assessment
                </Button>
              </>
            )}
          </>
        )}

        <Divider />

        <Card style={{ background: "#fafafa", borderRadius: 12 }}>
          <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
            <Image src={downloadJuknis} width={120} preview={false} />
            <div>
              <Title level={5}>Unduh Panduan Juknis Tools Assessment 2026</Title>
              <Button type="default" href="https://drive.google.com/file/d/1MTnGqiIxjUiiFXnann2eG8ULsW4WMpXg/view?usp=sharing" target="_blank">
                Download Juknis
              </Button>
            </div>
          </div>
        </Card>
      </Card>
    </div>
  );
}
